// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutMenu {
  height: 50px;
  width: 100%;
  line-height: 50px;
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
}
.aboutMenu ul {
  display: flex;
  width: 1200px;
  margin: 0px auto;
  border-left: 1px solid #ddd;
}
.aboutMenu ul li a {
  padding: 0px 25px;
  border-right: 1px solid #ddd;
  display: inline-block;
  font-size: 16px;
  height: 50px;
  color: #333;
  border-top: 1px solid #ddd;
}
.aboutMenu ul li.active a {
  background: #fff;
}
.aboutImg {
  width: 1200px;
  margin: 0px auto;
}
.aboutImg p {
  margin: 0px;
  color: #666;
}
.aboutImg-top {
  border-bottom: 1px solid #ddd;
  text-align: left;
  line-height: 30px;
  padding-bottom: 40px;
  padding-top: 50px;
}
.aboutImg-top h1 {
  font-size: 18px;
  margin: 0px;
}
.aboutImg-center {
  padding-top: 20px;
  display: flex;
  line-height: 30px;
  padding-bottom: 50px;
}
.aboutImg-center > div {
  text-align: left;
}
.aboutImg-center h3 {
  font-size: 16px;
  margin: 0px;
}
.aboutImg-center p {
  font-size: 14px;
}
.aboutImg-list {
  background: #fafbff;
  border: 1px solid #c8d4e9;
  border-radius: 4px;
  width: 40%;
  margin-top: 15px;
  text-align: center;
  line-height: 50px;
  font-size: 16px;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact/index.less"],"names":[],"mappings":"AAAA;EAAW,YAAA;EAAa,WAAA;EAAY,iBAAA;EAAmB,6BAAA;EAA8B,mBAAA;AAMrF;AANA;EACM,aAAA;EAAe,aAAA;EAAc,gBAAA;EAAkB,2BAAA;AAWrD;AAZA;EAEW,iBAAA;EAAkB,4BAAA;EAA6B,qBAAA;EAAsB,eAAA;EAAgB,YAAA;EAC1F,WAAA;EAAY,0BAAA;AAkBlB;AArBA;EAKkB,gBAAA;AAmBlB;AAjBA;EAAU,aAAA;EAAc,gBAAA;AAqBxB;AArBA;EACK,WAAA;EAAY,WAAA;AAwBjB;AAvBG;EAAM,6BAAA;EAA+B,gBAAA;EAAkB,iBAAA;EAAkB,oBAAA;EAAqB,iBAAA;AA8BjG;AA9BG;EACM,eAAA;EAAiB,WAAA;AAiC1B;AA/BG;EAAS,iBAAA;EAAkB,aAAA;EAAe,iBAAA;EAAkB,oBAAA;AAqC/D;AArCG;EACS,gBAAA;AAuCZ;AAxCG;EAEM,eAAA;EAAgB,WAAA;AA0CzB;AA5CG;EAGK,eAAA;AA4CR;AA1CG;EAAO,mBAAA;EAAoB,yBAAA;EAA0B,kBAAA;EAAmB,UAAA;EAAW,gBAAA;EAAkB,kBAAA;EAAoB,iBAAA;EAAkB,eAAA;EAAiB,WAAA;AAqD/J","sourcesContent":[".aboutMenu{height:50px; width:100%; line-height: 50px; border-bottom:1px solid #ddd; background:#f5f5f5;\n   ul{display: flex; width:1200px; margin: 0px auto; border-left:1px solid #ddd;}\n   ul li a{padding:0px 25px; border-right:1px solid #ddd; display:inline-block; font-size:16px; height:50px; \n      color:#333; border-top:1px solid #ddd;\n   }\n   ul li.active a{background:#fff;}\n}\n.aboutImg{width:1200px; margin:0px auto;\n   p{margin:0px; color:#666;}\n   &-top{border-bottom: 1px solid #ddd; text-align: left; line-height:30px; padding-bottom:40px; padding-top:50px;\n      h1{font-size: 18px; margin:0px;}\n   }\n   &-center{padding-top:20px; display: flex; line-height:30px; padding-bottom: 50px;\n      >div{ text-align:left;}\n      h3{font-size:16px; margin:0px;}\n      p{font-size:14px;}\n   }\n   &-list{background:#fafbff; border:1px solid #c8d4e9; border-radius:4px; width:40%; margin-top: 15px; text-align: center; line-height:50px; font-size: 16px; color:#333;}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
